/**
 * Returns a list of adapters for the given {@link AuthenticationInstance}
 */
export function getAdapters(instance) {
    return Object.values((instance === null || instance === void 0 ? void 0 : instance.adapters) || {});
}
